// Auto-generated file created by svgr-cli source svg-template.js
// Run pnpm run create to update
// Do not edit
import * as React from 'react';
import type { SVGProps } from 'react';
const SvgNavigationSplit = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="currentColor"
      d="M16.41 2.95c0-.223.26-.335.411-.177l3.27 3.396a.256.256 0 0 1 0 .353l-3.27 3.395c-.152.158-.412.046-.412-.177V7.302c-.28-.001-.564.009-.772.043a5.07 5.07 0 0 0-1.65.55c-1.467.813-1.97 1.35-2.886 2.332-.224.24-.472.505-.765.808a7.692 7.692 0 0 1-1.097.96c.366.257.722.583 1.097.97.293.302.541.568.765.807.917.981 1.42 1.52 2.885 2.333.5.277 1.056.451 1.65.55.209.033.492.044.773.042l.005-2.432c0-.222.26-.334.413-.176l3.269 3.395a.257.257 0 0 1 0 .353l-3.27 3.396c-.151.158-.411.046-.411-.177l-.008-2.439c-.41.006-.85-.004-1.163-.06a6.84 6.84 0 0 1-2.144-.739c-1.738-.963-2.432-1.708-3.389-2.735-.215-.23-.444-.477-.701-.742-.795-.82-1.329-1.11-2.134-1.25-.433-.074-.93-.08-1.57-.091-.424.007-1.39.003-2.17 0a.25.25 0 0 1-.241-.254v-1.5c0-.138.108-.25.24-.25.78-.003 1.747-.007 2.171 0 .64-.01 1.137-.014 1.57-.088.805-.14 1.339-.429 2.134-1.25.257-.265.486-.51.701-.742.957-1.026 1.651-1.771 3.389-2.735a6.843 6.843 0 0 1 2.144-.74c.313-.054.753-.065 1.163-.06z"
    />
  </svg>
);
export default SvgNavigationSplit;
